import { render } from "./LaborLogs.vue?vue&type=template&id=8869c042"
import script from "./LaborLogs.vue?vue&type=script&lang=js"
export * from "./LaborLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__